module.exports = __webpack_public_path__ + "static/media/tree-stump-3350196_640.0bd845d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tree-stump-3350196_640.jpg
// module id = 43
// module chunks = 0